import {DomainObject} from 'shared/store';
import {observable} from 'mobx';

class PublicInterviewSchedule extends DomainObject {
  @observable calendarEventName;
  @observable duration;
  @observable location;
  @observable address;
  @observable phoneNumber;
  @observable eventDescription;
  @observable videoConferencingProvider;
  @observable interviewers;
}

export default PublicInterviewSchedule;
